
import { Box } from "@mui/system";
import { max, min } from "lodash";
import { useState } from "react";
import Token from "../../../core/assets/oot/gshd/collected-skulltulas_32x32.png";
import GSToken from "../../../core/assets/oot/classic_improve/GS token.png";
import { SimpleItemProps } from "./SimpleItemProps";
import StaticItem from "../../../core/items/StaticItem";

const TokenItemCounter = () => {

    let [count, setCount] = useState(0);

    function countUp(ctrlKey: boolean) {
        if (ctrlKey)
            setCount(min([count + 10, 100]) ?? 0)
        else
            setCount(min([count + 1, 100]) ?? 0)
    }

    function countDown(ctrlKey: boolean) {
        if (ctrlKey)
            setCount(max([count - 10, 0]) ?? 0)
        else
            setCount(max([count - 1, 0]) ?? 0)
    }

    return <Box onClick={(e) => {
        countUp(e.ctrlKey)
    }}

        onContextMenu={(e) => { e.preventDefault(); countDown(e.ctrlKey) }} position="relative">
        <Box justifyContent={"center"} width="100%" fontSize={18} fontWeight={"bold"} display={"flex"} position={"absolute"}>{count}</Box>
        <img src={Token} alt="token" width={32} height={32} />

    </Box>
}

export default TokenItemCounter;


export const SimpleGoldenSkultulaItem= (props: SimpleItemProps) => {

     return <StaticItem
        image={GSToken}
        onClick={props.onClick}
        name={"Token"}
    />


}